import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import {
  BASED_ON_JSON,
  CREDITED_AC,
  MONTHS_WITHOUT_ALL,
  TYPE_JSON,
  USER_TYPE_JSON,
} from '../../../../../utils/courseIncome/constaints';
import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export default function CourseIncomeFIlter({
  month,
  setMonth,
  year,
  setYear,
  type,
  setType,
  userType,
  setUserType,
  creditedAcc,
  setCreditedAcc,
  basedOn,
  setBasedOn,
}) {
  const creditedAccountOptions = CREDITED_AC.filter((item) => item.label !== 'N/A');

  const DropDownJsonFirstSection = [
    { label: 'Based On', value: basedOn, setValue: setBasedOn, data: BASED_ON_JSON, width: 200 },
    { label: 'Type', value: type, setValue: setType, data: TYPE_JSON, width: 180 },
    { label: 'User Type', value: userType, setValue: setUserType, data: USER_TYPE_JSON, width: 140 },
  ];
  const DropDownJsonSecondSection = [
    { label: 'Credited A/C', value: creditedAcc, setValue: setCreditedAcc, data: creditedAccountOptions },
    {
      label: 'Month',
      value: month,
      setValue: setMonth,
      data: MONTHS_WITHOUT_ALL,
      itemValue: 'name',
      disable: type?.id === 1,
    },
  ];

  return (
    <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} gap={1} maxWidth={{ xs: '100%', lg: 1000 }}>
      <Box display={'flex'} gap={1} width={'100%'} flexDirection={{ xs: 'column', sm: 'row' }}>
        {DropDownJsonFirstSection.map(({ data, label, setValue, value, width }, i) => (
          <GlobalSelectFieldWithoutFormikNew
            key={i}
            data={data}
            keys={{
              itemId: 'id',
              itemValue: 'label',
            }}
            label={label}
            selectedDetails={value}
            setChange={setValue}
            sx={{
              //   width: { xs: '100%', md: 150, lg: 200 },
              width: { xs: '100%', lg: width ?? '100%' },
            }}
          />
        ))}
      </Box>
      <Box display={'flex'} gap={1} width={'100%'} flexDirection={{ xs: 'column', sm: 'row' }}>
        {DropDownJsonSecondSection.map(({ data, label, setValue, value, itemValue, disable }, i) => (
          <GlobalSelectFieldWithoutFormikNew
            key={i}
            data={data}
            keys={{
              itemId: 'id',
              itemValue: itemValue ?? 'label',
            }}
            label={label}
            selectedDetails={value}
            setChange={setValue}
            sx={{
              //   maxWidth: {xs:'100%',md:},
              width: '100%',
            }}
            disabled={Boolean(disable)}
          />
        ))}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={['year']}
            label="Year"
            sx={{
              width: { xs: '100%', md: 280 },
            }}
            onChange={(v) => setYear(v?.year())}
            // value={year}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
}
